// src/com/tsr/TransPlanTsrViewDetail.js
import React from 'react';
//import { Box } from '@mui/system';
import { styled } from '@mui/material/styles';
import { Box, Button, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
//import { AppWord, AppObject, AppStyle } from '../../value/AppConst';
import CheckIcon from '@mui/icons-material/Check';
import IsValid from '../../value/IsValid';
import { transPlanTsrItemRepo, userInfoRepo } from '../../value/AppModel';
import { useMutation, useReactiveVar } from '@apollo/client';
import { AppStyle, AppWord } from '../../value/AppConst';
import { TAKE_AT_STORE_TRANS_PLAN_SEAL_CHECK_INFO } from '../trans_plan_seal_check_info/TransPlanSealCheckInfoGql';
import { useSnackbar } from 'notistack';
import { useAlertSetter } from '../../api/app-hook';

const TitleCell = styled(TableCell)({
    color: '#777', fontSize: '0.9rem',
});

const SubTitle = styled(Box)({color: '#999', fontSize: '0.8rem', paddingLeft: '0.5rem'});
const ValueBox = styled(Box)({
    flexGrow: 1, paddingRight: '1rem', textAlign: 'right',
});
const DotBorder = '1px dotted #aaa';
const TimeCell = ({datetime}) => {
    if(IsValid.datetime(datetime)) {
        // 12시 34분 형식으로 변환
        const segments = datetime.split(/\D/);
        const hh = segments[3];
        const mm = segments[4];
        return <TableCell>{`${hh}시 ${mm}분`}</TableCell>;
    }
    return <TableCell>{datetime}</TableCell>;
}

/**
 * 상차 상세내역.
 * PC 버전: TransPlanTsrEditDetail
 * 상위 컴포넌트: TransPlanTsrGroup
 * @param {*} param0 
 * @returns 
 */
export default function TransPlanTsrViewDetail({
    onCompleteTakingOverCargo // 점포 인수 완료 후 호출 - transPlanTsrItemRepo 다시 업데이트.
}) {
    const sessionInfo = useReactiveVar(userInfoRepo);
    const item = useReactiveVar(transPlanTsrItemRepo);
    const addAlert = useAlertSetter();
    const { enqueueSnackbar } = useSnackbar();
    const [takeAtStoreTransPlanSealCheckInfo, responseTaking] = useMutation( TAKE_AT_STORE_TRANS_PLAN_SEAL_CHECK_INFO, {
        onCompleted: (data, option) => onCompleteTakingOver(data, option), 
        onError: (error) => addAlert({title: '점포인수 오류', message: [error.message]})
    } );

    const onCompleteTakingOver = (data, clientOption) => {
        if(data.transPlanSealCheckInfoTakeAtStore.ok) {
            enqueueSnackbar('점포 인수가 완료되었습니다.', {variant: 'success', autoHideDuration: 1500});
            onCompleteTakingOverCargo();
        }
        else addAlert({title:'점포인수 오류', message:[data.transPlanSealCheckInfoTakeAtStore.message]});
    };

    const onClickTakeOverCargo = () => {
        // 인수후 onCompleteTakingOverCargo 호출.
        const ok = window.confirm(`차량 ${item.vehPlates}에 대해 인수를 확정하시겠습니까? (${item.planId})`);

        if(ok) {
            const param = {planId: item.planId};
            takeAtStoreTransPlanSealCheckInfo({variables: {transPlanSealCheckInfo: param}});
        }
    };

    return(
        <TableContainer>
            <Table size={AppWord.SMALL}>
                <TableBody>
                    <TableRow>
                        <TitleCell rowSpan={3}>BOL</TitleCell>
                        <TableCell colSpan={3}>{item.bol1}&nbsp;</TableCell>
                    </TableRow>
                    <TableRow><TableCell colSpan={3}>{item.bol2}&nbsp;</TableCell></TableRow>
                    <TableRow><TableCell colSpan={3}>{item.bol3}&nbsp;</TableCell></TableRow>
                    <TableRow>
                        <TitleCell>상차수량</TitleCell>
                        <TableCell colSpan={3}>{item.loadCount}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TitleCell>상차시작</TitleCell><TimeCell datetime={item.loadStTime} />
                        <TitleCell>상차종료</TitleCell><TimeCell datetime={item.loadEnTime} />
                    </TableRow>
                    <TableRow>
                        <TitleCell>출발예정</TitleCell><TimeCell datetime={item.prosDptrTime} />
                        <TitleCell>도착예정</TitleCell><TimeCell datetime={item.prosArrTime} />
                    </TableRow>
                    <TableRow>
                        <TitleCell>봉인번호</TitleCell>
                        <TableCell>{item.sealNo1}</TableCell>
                        <TableCell>{item.sealNo2}</TableCell>
                        <TableCell>{item.sealNo3}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TitleCell>상차작업자</TitleCell>
                        <TableCell colSpan={3}>{item.loadStaffName}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TitleCell>특이사항</TitleCell>
                        <TableCell colSpan={3}>{item.memo}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TitleCell colSpan={4}>전일미출고</TitleCell>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={4}>
                            <Box style={{display:'flex', alignItems:'center'}}>
                                <SubTitle>BOL</SubTitle>
                                <ValueBox>{item.unsoldBol}</ValueBox>
                                <SubTitle style={{borderLeft:DotBorder}}>Pallet</SubTitle>
                                <ValueBox>{item.unsoldPallet}</ValueBox>
                                <SubTitle style={{borderLeft:DotBorder}}>수량</SubTitle>
                                <ValueBox>{item.unsoldCount}</ValueBox>
                            </Box>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TitleCell colSpan={4}>점포 인수인계 현황</TitleCell>
                    </TableRow>
                    <TableRow>
                        <TitleCell>인계자</TitleCell>
                        <TableCell>{item.passName}</TableCell>
                        <TitleCell>인수자</TitleCell>
                        <TableCell>
                            {
                                sessionInfo.isStoreUser() && !item.takeSealDate
                                ?
                                <Button
                                    variant={AppStyle.mui.contained}
                                    color={AppStyle.mui.secondary}
                                    startIcon={<CheckIcon />}
                                    onClick={onClickTakeOverCargo}
                                    size={AppWord.SMALL}
                                    disabled={responseTaking.loading}
                                >
                                    인수하기
                                </Button>
                                :
                                item.takeName
                            }
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
}

// takeSealDate